module.exports = __webpack_public_path__ + "static/img/genesisMount.57b0f66.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/VX/genesisMount.gif
// module id = M6Nr
// module chunks = 1